// extracted by mini-css-extract-plugin
module.exports = {"favoriteIcon":"Favorite_favoriteIcon__2TrNG","favoriteSvg":"Favorite_favoriteSvg__4dMZ9","pulse":"Favorite_pulse__2_luf","imgRounded":"Favorite_imgRounded__2Qk-s"};